import type { ReactNode } from 'react'

import { TooltipProvider } from '../tooltip-provider/tooltip-provider'

export const DsCoreProvider = ({ children }: { children: ReactNode }) => <TooltipProvider>{children}</TooltipProvider>
